<template>
  <Card
    class="container"
    :class="{'no-card': noCard}"
  >
    <v-expansion-panels
      v-model="panel"
      flat
    >
      <v-expansion-panel :title="title">
        <v-expansion-panel-text>
          <div
            v-for="(requirementValue, index) in supplierRequirementValues"
            :key="index"
          >
            <div
              v-if="isShowFile(requirementValue)"
              class="d-flex flex-column ga-2 mb-5"
            >
              <div class="file-title">
                {{ requirementValue.name }}
              </div>
              <FileInput
                title="Файл"
                without-title
                no-card
                without-sub-title
                :documents="requirementValue.valueFile ? [requirementValue.valueFile] : []"
                :download-file="() => downloadSupplierRequirementDocument(requirementValue)"
              />
            </div>
            <v-text-field
              v-else
              style="pointer-events: none;"
              variant="underlined"
              readonly
              :label="requirementValue.name"
              :model-value="$t(String(displayRequirementValue(requirementValue)))"
            />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </Card>
</template>

<script setup lang="ts">
import Card from "@intec/vue-components/form/Card.vue";
import FileInput from '@intec/vue-components/form/FileInput.vue';
import { ref } from "vue";
import { SUPPLIER_REQUIREMENT_TYPE } from "@/lib/supplierRequirement";
import { formatDate } from "@/filters";
import { useI18n } from 'vue-i18n';

interface SupplierRequirementFile {
  id: number;
  name: string;
  downloadUrl: string;
  [key: string]: any;
}

interface SupplierRequirementValue {
  id: number;
  supplierRequirementId: number;
  type: string;
  name: string;
  valueText?: string;
  valueNumber?: number;
  valueBool?: boolean;
  valueDate?: Date;
  valueList?: number;
  list?: Array<{ id: number; value: string }>;
  valueFile?: SupplierRequirementFile;
  [key: string]: any;
}

interface Props {
  noCard?: boolean;
  supplierRequirementValues: SupplierRequirementValue[];
}

const props = defineProps<Props>();
const { t } = useI18n()

const panel = ref(0); // с 0 - панель открыта по умолчанию.
const title = t('Требования к участнику ({_1})', { '_1': props.supplierRequirementValues.length })

const isShowFile = (requirementValue: SupplierRequirementValue): boolean => {
  return requirementValue.type === SUPPLIER_REQUIREMENT_TYPE.FILE
    && !!requirementValue.valueFile;
};

// Функция для отображения значения в зависимости от типа.
const displayRequirementValue = (requirementValue: SupplierRequirementValue): string | number => {
  switch (requirementValue.type) {
    case SUPPLIER_REQUIREMENT_TYPE.TEXT:
      return requirementValue.valueText || 'Не указано';
    case SUPPLIER_REQUIREMENT_TYPE.NUMBER:
      return requirementValue.valueNumber || 'Не указано';
    case SUPPLIER_REQUIREMENT_TYPE.DATE:
      return requirementValue.valueDate
        ? formatDate(requirementValue.valueDate.toISOString())
        : 'Не указано';
    case SUPPLIER_REQUIREMENT_TYPE.BOOL:
      return requirementValue.valueBool ? 'Да' : 'Нет';
    case SUPPLIER_REQUIREMENT_TYPE.LIST:
      const selected = requirementValue.list?.find(
        (item) => item.id === requirementValue.valueList
      );
      return selected?.value || 'Не выбрано';
    case SUPPLIER_REQUIREMENT_TYPE.FILE:
      return 'Не приложен';
    default:
      return 'Не указано';
  }
};

const downloadSupplierRequirementDocument = async (requirementValue: SupplierRequirementValue) => {
  window.location.href = requirementValue?.valueFile?.downloadUrl;
};

</script>

<style scoped>
.no-card {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.file-title {
  font-size: 13px;
  opacity: var(--v-medium-emphasis-opacity);
}

:deep(.v-expansion-panel-text__wrapper) {
  padding: 0;
}

:deep(.v-expansion-panel-title) {
  padding: 22px 0;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
}
</style>
